{
  "name": "mastra",
  "version": "1.15.0",
  "license": "Apache-2.0",
  "description": "cli for mastra",
  "type": "module",
  "main": "dist/index.js",
  "types": "dist/index.d.ts",
  "bin": {
    "mastra": "./dist/index.js"
  },
  "exports": {
    ".": "./dist/index.js",
    "./package.json": "./package.json",
    "./telemetry-loader": "./dist/commands/dev/telemetry-loader.js",
    "./dist/*": [
      "./dist/*",
      "./dist/*.js"
    ]
  },
  "files": [
    "dist",
    "CHANGELOG.md"
  ],
  "scripts": {
    "generate:api-manifest": "pnpm --filter @mastra/server generate:api-cli-route-metadata",
    "build:lib": "tsup --silent --config tsup.config.ts",
    "prepack": "tsx ../../scripts/generate-package-docs.ts",
    "test": "vitest run",
    "test:watch": "vitest watch",
    "clean": "rm -rf dist && rm -rf node_modules",
    "typecheck": "tsc --noEmit --incremental",
    "lint": "eslint ."
  },
  "keywords": [
    "mastra",
    "cli",
    "ai",
    "llm",
    "llms",
    "agent",
    "agents",
    "dev",
    "development",
    "deploy",
    "deployment",
    "build",
    "workflow",
    "typescript",
    "command-line",
    "devtools"
  ],
  "dependencies": {
    "@babel/parser": "^7.29.7",
    "@babel/types": "^7.29.7",
    "@clack/prompts": "^1.1.0",
    "@expo/devcert": "^1.2.1",
    "@mastra/deployer": "workspace:^",
    "@mastra/loggers": "workspace:^",
    "archiver": "^8.0.0",
    "commander": "^14.0.3",
    "dotenv": "^17.3.1",
    "execa": "^9.6.1",
    "fs-extra": "^11.3.5",
    "get-port": "^7.1.0",
    "local-pkg": "^1.1.2",
    "openapi-fetch": "^0.17.0",
    "picocolors": "^1.1.1",
    "posthog-node": "^5.37.0",
    "semver": "^7.7.4",
    "serve": "^14.2.6",
    "serve-handler": "^6.1.7",
    "shell-quote": "^1.8.3",
    "strip-json-comments": "^5.0.3",
    "tinyglobby": "^0.2.17",
    "yocto-spinner": "^1.1.0"
  },
  "devDependencies": {
    "@commander-js/extra-typings": "^14.0.0",
    "@internal/lint": "workspace:*",
    "@internal/playground": "workspace:*",
    "@internal/types-builder": "workspace:*",
    "@mastra/core": "workspace:*",
    "@types/archiver": "^8.0.0",
    "@types/fs-extra": "^11.0.4",
    "@types/node": "22.19.21",
    "@types/semver": "^7.7.1",
    "@types/serve-handler": "^6.1.4",
    "@types/shell-quote": "^1.7.5",
    "@vitest/coverage-v8": "catalog:",
    "@vitest/ui": "catalog:",
    "eslint": "^10.4.1",
    "memfs": "^4.56.11",
    "rollup": "^4.61.1",
    "tsup": "^8.5.1",
    "tsx": "catalog:",
    "type-fest": "^5.4.4",
    "typescript": "catalog:",
    "vitest": "catalog:",
    "zod": "catalog:"
  },
  "peerDependencies": {
    "@mastra/core": ">=1.34.0-0 <2.0.0-0"
  },
  "homepage": "https://mastra.ai",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/mastra-ai/mastra.git",
    "directory": "packages/cli"
  },
  "bugs": {
    "url": "https://github.com/mastra-ai/mastra/issues"
  },
  "engines": {
    "node": ">=22.13.0"
  }
}
